'use client';

import styles from './InputAndBtn.module.css';
import React, { useState } from 'react';
import { useTrackHandler } from '@/lib/hooks/useTrackHandler';
import { ButtonFilled } from '@/components/ui/Button/ButtonFilled';
import IconReact from '@/components/ui/Icon/IconReact';

export const InputAndBtn = () => {
    const [input, setInput] = useState('');
    const { handleTrackClick, error, clearError } = useTrackHandler(input);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (error) clearError();
        setInput(e.target.value);
    };

    return (
        <section>
            <div className={styles.inputGroup}>
                <input
                    value={input}
                    onChange={handleChange}
                    className={`${styles.input} ${error ? styles.inputError : ''}`}
                    placeholder="Введите номер заказа"
                />
                <ButtonFilled full={false} onClick={handleTrackClick}>
                    <IconReact name="Search" size={'20px'} />
                    <span className="ml-2 block sm:hidden">Найти</span>
                </ButtonFilled>

                {error && <p className={styles.error}>{error}</p>}
            </div>
        </section>
    );
};
